<template>
  <fragment>
    <slot
      :take-study-handler="takeStudyHandler"
      :take-study-loading="beginLoading"
      :is-study-can-be-taken="isStudyCanBeTaken"
    />
    <portal to="additional-popups">
      <b-modal
        size="xl"
        :visible="isUserProfilePopupVisible"
        class="v3_modal"
        :header-class="'align-items-center border_0'"
        :body-class="'p-0'"
        hide-footer
        @hidden="isUserProfilePopupVisible = false"
      >
        <template slot="modal-header">
          <h2 class="font_size_1125rem">User Profile</h2>
          <div class="d-flex align-items-center justify-content-between">
            <b-button variant="v3_teal_outline" @click="onUserProfileSave">
              <template v-if="!userProfilePopupLoading">Save</template>
              <b-spinner v-else small />
            </b-button>
            <b-button
              variant="v3_red_outline"
              class="ml-3"
              @click="isUserProfilePopupVisible = false"
            >
              Cancel
            </b-button>
          </div>
        </template>
        <user-profile-form
          ref="userProfileModal"
          @profile-form-submit="onProfileSubmit"
          @profile-form-cancel="isUserProfilePopupVisible = false"
          @validate-failed="userProfilePopupLoading = false"
        />
      </b-modal>
    </portal>
  </fragment>
</template>

<script>
import UserProfileForm from '@/components/users/profile/UserProfileForm';
import Api from '@/providers/Api';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import { CREATE_SURVEY_ACTION } from '@/store';
export default {
  name: 'TakeStudyWithProfileValidationBehaviour',
  components: {
    UserProfileForm,
  },
  props: {
    questionnaire: Object,
  },
  data: function () {
    return {
      isUserProfilePopupVisible: false,
      userProfilePopupLoading: false,
      beginLoading: false,
    };
  },
  computed: {
    user: function () {
      return this.$store.state.user;
    },
    study: function () {
      return this.questionnaire && this.questionnaire.survey
        ? this.questionnaire.survey
        : null;
    },
    isStudyCanBeTaken: function () {
      return (
        this.questionnaire &&
        this.questionnaire.isActive &&
        this.user &&
        this.questionnaire.societyMembershipTypes && this.questionnaire.societyMembershipTypes.some(
          ({ id }) => id === this.user.society_membership_type_id
        )
      );
    },
  },
  methods: {
    onUserProfileSave: function () {
      this.userProfilePopupLoading = true;
      this.$refs.userProfileModal &&
        typeof this.$refs.userProfileModal.save === 'function' &&
        this.$refs.userProfileModal.save();
    },
    onProfileSubmit: function () {
      this.userProfilePopupLoading = false;
      this.isUserProfilePopupVisible = false;
      this.beginStudy();
    },
    continueStudy: function () {
      this.$router.push(`/surveyForm/${this.study.id}`);
    },
    beginStudy: async function () {
      this.beginLoading = true;
      try {
        const isUserProfileFilled = await Api.isUserProfileFilled();
        if (!isUserProfileFilled) {
          this.isUserProfilePopupVisible = true;
          return;
        }
        const survey = await this.$store.dispatch(CREATE_SURVEY_ACTION, {
          questionnaireId: this.questionnaire.id,
        });
        this.$router.push(`/surveyForm/${survey.id}`);
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      } finally {
        this.beginLoading = false;
      }
    },
    takeStudyHandler: function () {
      this.study ? this.continueStudy() : this.beginStudy();
    },
  },
};
</script>

<style scoped></style>
